import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  commodities: [],
  orderCountAnalytic: {},
  orderByStage: {},
  commodityWiseOrders: [],
  rejectedOrders: {},
  disputeAnalysis: {},
  reportReviewStatus: {},
};

const labDashboardSlice = createSlice({
  name: "labDashboard",
  initialState,
  reducers: {
    fetchCommodities(state) {},
    fetchCommoditiesSuccess(state, action) {
      state.commodities = action.payload.data.document;
    },
    fetchCommoditiesFailure(state, action) {},

    getOrderCountAnalytic(state) {},
    getOrderCountAnalyticSuccess(state, action) {
      state.orderCountAnalytic = action.payload?.data?.results;
    },
    getOrderCountAnalyticFailure(state, action) {},

    getOrderByStage(state) {},
    getOrderByStageSuccess(state, action) {
      state.orderByStage = action.payload?.data;
    },
    getOrderByStageFailure(state, action) {},

    getCommodityWiseOrders(state) {},
    getCommodityWiseOrdersSuccess(state, action) {
      state.commodityWiseOrders = action.payload?.data;
    },
    getCommodityWiseOrdersFailure(state, action) {},

    getRejectedOrders(state) {},
    getRejectedOrdersSuccess(state, action) {
      state.rejectedOrders = action.payload?.data;
    },
    getRejectedOrdersFailure(state, action) {},

    getDisputeAnalysis(state) {},
    getDisputeAnalysisSuccess(state, action) {
      state.disputeAnalysis = action.payload?.data;
    },
    getDisputeAnalysisFailure(state, action) {},

    getReportReviewStatus(state) {},
    getReportReviewStatusSuccess(state, action) {
      state.reportReviewStatus = action.payload?.data;
    },
    getReportReviewStatusFailure(state, action) {}
  },
});

export const { actions, reducer, name: sliceKey } = labDashboardSlice;
